/**
 * Форматирование чисел и дат по активному языку (B1).
 *
 * Жёсткое `'ru-RU'` в коде — это половина непереведённого интерфейса:
 * подписи на английском, а «1 250» с неразрывным пробелом и «21.08.2026»
 * остаются русскими. Разделители, порядок частей даты и даже система счисления
 * зависят от языка, и угадывать их нельзя.
 */
import { i18n } from './index';

const locale = (): string => i18n.resolvedLanguage ?? 'en';

export const formatNumber = (value: number, options?: Intl.NumberFormatOptions): string =>
  value.toLocaleString(locale(), options);

export const formatMoney = (value: number, currency: string): string =>
  value.toLocaleString(locale(), { style: 'currency', currency, maximumFractionDigits: 0 });

export const formatDate = (value: string | Date, options?: Intl.DateTimeFormatOptions): string =>
  new Date(value).toLocaleDateString(locale(), options);

export const formatDateTime = (value: string | Date, options?: Intl.DateTimeFormatOptions): string =>
  new Date(value).toLocaleString(locale(), options);

export const formatTime = (value: string | Date): string =>
  new Date(value).toLocaleTimeString(locale());
